import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'
import { Attachment } from './Attachment'
import isEmpty from 'lodash/isEmpty'

export default function Attachments({ attachments = [], canDownload = false }) {
  const sortedAttachments = useMemo(() => {
    // check if attachments contains an empty object
    // if so, remove it from the array
    return attachments.filter(attachment => !isEmpty(attachment)).sort((a, b) => {
      if (a.created_at > b.created_at) return -1
      if (a.created_at < b.created_at) return 1
      return 0
    })
  }, [attachments])

  return (
    <Box
      display='flex'
      flexDirection='column'
      height='100%'
      minHeight='100%'
      color='colorTextMain'
    >
      { sortedAttachments.length === 0 && <Box>No attachments</Box> }
      { sortedAttachments.length > 0 && (
        <Box
          overflow='auto'
          borderTopWidth='1px'
          borderTopColor='colorBorderMain'
          borderTopStyle='solid'
        >
          { sortedAttachments.map((item, index) => <Attachment key={index} item={item} canDownload={canDownload} />) }
        </Box>
      )}
    </Box>
  )
}

Attachments.propTypes = {
  attachments: PropTypes.array.isRequired,
  canDownload: PropTypes.bool,
}
